import { Injectable } from "@angular/core";
import { Analytics } from "@aws-amplify/analytics";

@Injectable({
    providedIn: "root",
})
export class AwsKinesisAnalyticsService {
    currentSingletonServiceInstance: typeof Analytics;

    constructor() {}

    getInstance(): any {
        return this.currentSingletonServiceInstance;
    }

    setInstance(analytics: typeof Analytics): void {
        console.log(
            `currentSingletonServiceInstance has been set with ${analytics}`,
        );
        this.currentSingletonServiceInstance = analytics;
    }
}
